import {useMemo} from 'react';
import {CartItem} from 'src/types/TransactionDetail';
import {isFreeText} from '../utils/promo';

export const useSortedModifiers = (mods: CartItem['Modifiers'] = []) =>
  useMemo(() => {
    if (!mods.length) {
      return [];
    }

    const sorted = [...mods].sort((a, b) => b.Price - a.Price);

    const idx = sorted.findIndex((m) => isFreeText(m.SeatNbr, m.Type));
    if (idx !== -1) {
      const [msg] = sorted.splice(idx, 1);
      sorted.push(msg);
    }
    return sorted;
  }, [mods]);
